// React
import React from "react";
import CalendarEdit from "./CalendarEdit";

const GroupCalendarEditBirthdays = props => (
    <CalendarEdit {...props} calendarType="birthdays" />
);
export default GroupCalendarEditBirthdays;